// Preload función para componentes críticos con detección de conexión y móvil
import { detectMobileDevice } from "@/lib/IsMobil";

// Definir un tipo para la propiedad connection en Navigator, ya que no es estándar en todas partes
interface NavigatorWithConnection extends Navigator {
  connection?: NetworkInformation;
}

interface NetworkInformation extends EventTarget {
  readonly effectiveType?: "slow-2g" | "2g" | "3g" | "4g";
  readonly saveData?: boolean;
  readonly type?: string;
}

const isCellularOrSaveData = () => {
  const nav = navigator as NavigatorWithConnection;
  const c = nav.connection;
  const eff = c?.effectiveType ?? "";
  const slow = /(slow-2g|2g|3g)/i.test(eff);
  const cell = /cellular/i.test(c?.type ?? "");
  return Boolean(c?.saveData || slow || cell);
};

const isMobileEnvironment = () => {
  return detectMobileDevice() || isCellularOrSaveData();
};

export const preloadCriticalComponents = () => {
  // En móvil o redes celulares/ahorro de datos, solo cargar componentes Lite
  if (isMobileEnvironment()) {
    // Solo precargar componentes Lite después de 1s para mejorar navegación móvil
    setTimeout(() => {
      import("@/pages/menu/HomeLite" /* webpackChunkName: "home-lite" */);
      // No cargar Settings ni PanelDeAdministracion en móvil a menos que se abran específicamente
    }, 1000);
    return;
  }

  // Escritorio/conexiones rápidas: precargar Home y Settings normales
  setTimeout(() => {
    import("@/pages/menu/Home" /* webpackChunkName: "home" */);
    import("@/pages/menu/Settings" /* webpackChunkName: "settings" */);
  }, 1000);

  // Precargar admin después de 3 segundos solo en escritorio
  setTimeout(() => {
    import(
      "@/pages/settings/PanelDeAdministracion" /* webpackChunkName: "admin-panel" */
    );
  }, 3000);
};
